/**
 * 盤點掃碼上方 notice 四欄：庫存編號／物料代號／物料名稱／數量。
 */

function trimText(value) {
  return String(value ?? '').trim();
}

function dashIfEmpty(value) {
  const text = trimText(value);
  return text || '';
}

/**
 * 從盤點 scan line 組 notice 欄位。
 * @param {object|null|undefined} line
 * @param {string} [fallbackStockNo]
 */
export function buildScanNoticeFieldsFromLine(line, fallbackStockNo = '') {
  return {
    stockNo: dashIfEmpty(line?.stockNo) || trimText(fallbackStockNo),
    mtrNo: dashIfEmpty(line?.mtrNo),
    mtrName: dashIfEmpty(line?.mtrName),
    qty: line?.countedQty ?? line?.systemQty ?? '',
  };
}

/**
 * 從 inventory-stock row 組 notice 欄位。
 * @param {object|null|undefined} row
 * @param {string} [fallbackStockNo]
 */
export function buildScanNoticeFieldsFromRow(row, fallbackStockNo = '') {
  if (!row) {
    return {
      stockNo: trimText(fallbackStockNo),
      mtrNo: '',
      mtrName: '',
      qty: '',
    };
  }

  return {
    stockNo: dashIfEmpty(row.stockNo) || trimText(fallbackStockNo),
    mtrNo: dashIfEmpty(row?.mtr?.mtrNo),
    mtrName: dashIfEmpty(row?.mtr?.name),
    qty: row?.systemQty ?? row?.baseQty ?? '',
  };
}

/**
 * 在既有 lines 依 invStockId／stockNo 找列。
 * @param {object[]} lines
 * @param {{ invStockId?: string|null, stockNo?: string|null }} match
 */
export function findExistingScanLine(lines, { invStockId = null, stockNo = null } = {}) {
  const id = invStockId || null;
  const no = trimText(stockNo);
  const list = Array.isArray(lines) ? lines : [];

  return list.find((line) => {
    const lineId = line?.invStockId || line?.inventoryStockId || null;
    if (id && lineId && lineId === id) {
      return true;
    }
    if (no && trimText(line?.stockNo) === no) {
      return true;
    }
    return false;
  }) ?? null;
}
